/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * List of resource identifiers
 */
import { ValidateUtils } from 'app/shared/utils';

export class ResourceIdentifierList { 
    /**
     * Resource identifier
     */
    resourceIdentifiers?: Array<string>;

    constructor(item?: Partial<ResourceIdentifierList>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            resourceIdentifiers: {
                type: 'uuid',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.resourceIdentifiers : itemOrValue;

                    if (itemOrValue?.resourceIdentifiers != null) {
                        if (itemOrValue.resourceIdentifiers === '') {
                            itemOrValue.resourceIdentifiers = undefined;
                        } else if (['int32', 'int64'].indexOf('uuid') >= 0) {
                            itemOrValue.resourceIdentifiers = parseInt(itemOrValue.resourceIdentifiers.toString(), 10);
                        } else if (['float'].indexOf('uuid') >= 0) {
                            itemOrValue.resourceIdentifiers = parseFloat(itemOrValue.resourceIdentifiers.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uuid');
                    if (['uuid'].indexOf('uuid') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ResourceIdentifierList.isValid,
        };
    }

    static isValid(obj: ResourceIdentifierList): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ResourceIdentifierList.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.resourceIdentifiers.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

